export default __webpack_public_path__ + "static/media/businessPeople.25cd10f0.jpg";